module.exports = __webpack_public_path__ + "img/bar-chart-01.7f51411a.svg";